import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "area_section"
}
const _hoisted_2 = { class: "area_contents" }
const _hoisted_3 = { class: "area_contents_title" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "area_contents_body" }
const _hoisted_6 = { class: "areaGrid" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = {
  key: 0,
  rowspan: "2"
}
const _hoisted_10 = {
  key: 1,
  rowspan: "2"
}
const _hoisted_11 = {
  key: 1,
  class: "area_section"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.state.data != null && $setup.state.data.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              textContent: _toDisplayString($setup.state.headerData.title)
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.headerData.types, (item) => {
                    return (_openBlock(), _createElementBlock("th", {
                      scope: "col",
                      innerHTML: item
                    }, null, 8, _hoisted_7))
                  }), 256))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.years, (year) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: year }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        textContent: _toDisplayString(year),
                        rowspan: "2"
                      }, null, 8, _hoisted_8),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.headerData.keys, (key) => {
                        return (_openBlock(), _createElementBlock("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCnAndYear(year, key, $setup.state.data))), 1))
                      }), 256)),
                      ($setup.state.headerData.title !== '실인원')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString($setup.CommonUtils.numberFormat(
                                            $setup.state.headerData.keys.reduce(
                                                (sum, t) => sum + $setup.CommonUtils.getCntByCnAndYear(year, t, $setup.state.data),
                                                0,
                                            ),
                                        )), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(Math.round(
                                            ($setup.CommonUtils.getCntByCnAndYear(year, 999, $setup.state.data) /
                                                $setup.CommonUtils.getCntByCnAndYear(year, 998, $setup.state.data)) *
                                                10000,
                                        ) /
                                            100 +
                                        "(%)"), 1))
                    ]),
                    _createElementVNode("tr", null, [
                      ($setup.state.headerData.title !== '실인원')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.headerData.keys, (key) => {
                            return (_openBlock(), _createElementBlock("td", null, _toDisplayString($setup.CommonUtils.getCntByCnAndYear(year, key, $setup.state.data) > 0
                                            ? (
                                                  ($setup.CommonUtils.getCntByCnAndYear(year, key, $setup.state.data) /
                                                      $setup.state.headerData.keys.reduce(
                                                          (sum, t) => sum + $setup.CommonUtils.getCntByCnAndYear(year, t, $setup.state.data),
                                                          0,
                                                      )) *
                                                  100
                                              ).toFixed(2) + "%"
                                            : 0), 1))
                          }), 256))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11))
}